export function dateFormat(date) {
    let options = {
        day: "numeric", 
        month: "short", 
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "Asia/Singapore",
        timeZoneName: "short"
    }
    return date.toLocaleTimeString('default', options);
}
